<script lang="ts" setup>
  import { type PropType } from 'vue';

  type DiscountType = 'PERCENT' | 'FIXED';

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    type: { type: String as PropType<DiscountType>, required: true },
    value: { type: [String, Number], required: false },
  });
</script>
<template>
  <div class="discount-label">
    <p class="discount-label__value">
      <SfFormattedPercentage v-if="type === 'PERCENT'" :value="value" />
      <SfFormattedNumeric v-if="type === 'FIXED'" :value="value" />
    </p>
  </div>
</template>
<style lang="scss">
  :root {
    --sf-discount-label-padding-x: 0.5rem;
    --sf-discount-label-padding-y: 0.25rem;
    --sf-discount-label-radius: 0;
    --sf-discount-label-max-width: 4rem;
    --sf-discount-label-background: var(--primary-background);
    --sf-discount-label-color: var(--primary-foreground);
    --sf-discount-label-font-size: var(--font-size);
    --sf-discount-label-line-height: var(--line-height);
    --sf-discount-label-font-weight: var(--font-weight-bold);
  }

  .discount-label {
    text-align: center;
    padding: var(--sf-discount-label-padding-y) var(--sf-discount-label-padding-x);
    border-radius: var(--sf-discount-label-radius);
    background-color: var(--sf-discount-label-background);
    min-width: var(--sf-discount-label-max-width);
    line-height: var(--sf-discount-label-line-height);

    &__value {
      color: var(--sf-discount-label-color);
      font-weight: var(--sf-discount-label-font-weight);
    }
  }
</style>
